export function resetInlineStyles() {
	if (window.innerWidth <= 768) {
		const tinymceElements = document.querySelectorAll('.tinymce');
		tinymceElements.forEach((el) => {
			el.querySelectorAll('span[style]').forEach((span) => {
				span.style.removeProperty('font-size');
			});
		});
	}
}
